/* eslint-disable @typescript-eslint/no-explicit-any */
import { Spinner } from "@aurem/ui";
import { ComponentProps, ComponentType, lazy, Suspense } from "react";

const RouteFallback = () => (
  <div className="flex h-full w-full items-center justify-center p-6">
    <Spinner />
  </div>
);

export function lazyPage<C extends ComponentType<any>>(
  loader: () => Promise<{ default: C }>,
): C {
  const Component = lazy(loader);
  return ((props: ComponentProps<C>) => (
    <Suspense fallback={<RouteFallback />}>
      <Component {...props} />
    </Suspense>
  )) as unknown as C;
}
